<template>
  <div>
    <div class="social">
      <social-sharing :url="share.twitter.url"
                    :title="share.twitter.text"
                    :hashtags="share.twitter.hashtags"
                    network-tag="a"
                    inline-template>
        <div :class="['social-icon', 'social-icon__twitter']">
          <network network="twitter" :style="{'font-size': 0, 'width': '100%', 'height': '100%', 'display': 'block', 'cursor': 'pointer'}" :class="['social-icon', 'social-icon__twitter']">
            Twitter
          </network>
        </div>
      </social-sharing>
      <social-sharing :url="share.facebook.url"
                    :title="share.facebook.title"
                    :description="share.facebook.description"
                    :quote="share.facebook.quote"
                    network-tag="a"
                    inline-template>
        <div :class="['social-icon', 'social-icon__facebook']">
          <network network="facebook" :style="{'font-size': 0, 'width': '100%', 'height': '100%', 'display': 'block', 'cursor': 'pointer'}" :class="['social-icon', 'social-icon__twitter']">
            Facebook
          </network>
        </div>
      </social-sharing>
      <!-- <a class="social-icon social-icon__link" :href="`${share.linkedin.url}`" target="_blank"></a> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import SocialSharing from 'vue-social-sharing';

export default {
  computed: {
    ...mapState(["selectedProject", "sidebarActivities", "popupActivities"]),
    ...mapGetters(["getSelectedProject", "getInfographics"]),
    share() {
      return this.getInfographics.share || null;
    }
  },
  methods: {
    ...mapMutations(["setSelectedProject", "setSelectedScene"])
  },
  components: {
    SocialSharing
  }
};
</script>

<style lang="scss" scoped>
.social {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;

  &-icon {
    display: inline-block;
    width: 36px;
    height: 36px;
    background-image: url("../assets/social-media-icons/link.svg");
    background-position: center;
    background-size: cover;
    margin: 5px 0;
    vertical-align: middle;

    &__twitter {
      background-image: url("../assets/social-media-icons/twitter.svg");
    }

    &__facebook {
      background-image: url("../assets/social-media-icons/facebook.svg");
    }

    &__network {
      font-size: 0;
    }
  }
}

#social-icon__network {
  display: none;
}
</style>
